<template>
    <div class="reviews">
        <div v-for="page in pages" class="review-item">
            <p class="review-description">
                <span v-if="readonly" class="edited_content"  v-html="page.pagetext">
                </span>
                <inline-editor v-if="!readonly" :editable="page.pagetext" :pageid="page._id" dbentry="pagetext" element="textarea"/>
            </p>
            <strong class="review-title">    
                <span class="review-image" :style="'background-image: url('+page.blockimage+')'"></span>
                <span v-if="readonly" class="edited_content">
                    {{ page.pagetitle }} 
                </span>
                <inline-editor v-if="!readonly" :editable="page.pagetitle" :pageid="page._id" dbentry="pagetitle" element="normal"/>
            </strong>
        </div>
        <item-adder @clicked="getPages()" v-if="!readonly" :websiteid="websiteid" :parentpageid="pageid" placeholdertext="Naam van referentie" linktext="Referentie toevoegen"/>
    </div>
</template>

<script>
import ItemAdder from '../app/ItemAdder.vue';
import InlineEditor from '../app/InlineEditor.vue';

import axios from 'axios';

export default {
    components: {
        ItemAdder,
        InlineEditor
    },
    props: {
        pageid: String,
        websiteid: String,
        readonly: Boolean
    },
    data: function() {
        return{
            readonly: false,
            pages: {}
        }
    },
    methods: {
        getPages(){
            axios.get(process.env.VUE_APP_ROOT_API+'/pages/'+this.websiteid+'/'+this.pageid)
            .then(response => {
              console.log('pages loaded')
                this.pages = response.data.response
            })
        },
        removePage(id){
            axios.delete(process.env.VUE_APP_ROOT_API+'/pages/'+this.websiteid+'/'+id)
            .then(response => {
                console.log(response)
                this.showModal = false
            })
        }
    },
    mounted(){
        this.getPages()
    }
}
</script>

<style lang="scss">

  .reviews{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin: 0 15px;
  }
  .review-item{
    display: flex;
    flex-direction: column;
    background: #ffffff;
    border-radius: 10px;
    width: calc(50% - 40px);
    overflow: hidden;
    margin: 20px;
    padding: 50px 40px 40px;
  }
  .review-item:hover{
    text-decoration: none;
  }
  .review-image{
    display: inline-block;
    height: 50px;
    width: 50px;
    border-radius: 100px;
    overflow: hidden;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    background-color: #ebebeb;
    margin-right: 20px;
  }
  .review-title{
    display: block;
    color: #000000;
    display: flex;
    align-items: center;
  }
  .review-description{
    display: block;
    color: #999;
    font-size: 1.7rem;
    line-height: 1.2;
    font-weight: 300;
    position: relative;
    z-index: 1;
    &:before {
        content: '\201C';
        position: absolute;
        top: -.5rem;
        left: 0;
        color: darken(#ffffff, 9%);
        font-size: 2em;
        font-weight: 400;
        z-index: -1;
        line-height: .5;
    }
  }
  
  @media (max-width: 991px) {
    .review-item {
      width: calc(50% - 30px);
      margin: 15px;
    }
  }
  
  @media (max-width: 768px) {
    .review-item {
      width: 100%;
      margin: 10px;
    }
  }
</style>
